// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"credit-analysis_formContainer__3yj68"};